import { parseMarkdownToHtml } from '@/utils/helpers';

export type AboutUsProps = {
  storeProfile: AdaptedStore<true>['profile'];
  content: StoreProfilePageContent;
};

export function AboutUs({ storeProfile, content }: AboutUsProps) {
  return (
    <div className="flex flex-col items-start space-y-2.5">
      <h2 className="text-xl">{content.profile.aboutUs}</h2>

      <div
        className="text-sm"
        dangerouslySetInnerHTML={{
          __html: parseMarkdownToHtml(storeProfile.description),
        }}
      />
    </div>
  );
}
